/**
 * A fingerprint, for the passkey button.
 *
 * Deliberately **not** the FIDO passkey icon. That mark ships only from
 * fidoalliance.org behind a Trademark and Service Mark Usage Agreement, and
 * FIDO asks that custom versions of it get written approval — so drawing a
 * lookalike would be the one option that carries real risk. This is our own
 * artwork and makes no claim to be theirs, which is also why it is free to
 * match the 20px sizing of the marks beside it rather than FIDO's 24px floor.
 *
 * It inherits `currentColor` — unlike the third-party marks in
 * `provider-marks.tsx`, whose colours are fixed by their owners' guidelines.
 *
 * The one thing it gets slightly wrong is the concept: a passkey can be
 * unlocked by a device PIN or screen lock, not only by a fingerprint. The
 * label ("Continue with a passkey") carries the actual meaning, and the icon
 * is `aria-hidden`, so nothing depends on the glyph being exhaustive.
 */
export function PasskeyMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
      className="size-5 shrink-0"
    >
      {/* Nested ellipses around (12,12), taller than wide like a fingertip,
          each wrapping ~270° so the ridge ends point downward — arcs that stop
          level with the centre read as a stack of rainbows instead.
          The two ends of a ring stop at different angles on purpose: ends that
          line up turn the whole thing into a broadcast symbol, and staggering
          them is most of what makes it read as a fingerprint.
          Three rings, not four: at 20px a fourth closes the gaps to under a
          pixel and the whole thing mushes. */}
      <path d="M6.65 19.06A8 9.5 0 1 1 17.75 18.6" />
      <path d="M9.19 17.43A5.3 6.4 0 1 1 16.29 15.76" />
      <path d="M10.99 15.06A2.7 3.3 0 1 1 14.38 13.55" />
    </svg>
  );
}
